import { render, staticRenderFns } from "./sys_work_logs_detail.vue?vue&type=template&id=570ab4bc&scoped=true"
import script from "./sys_work_logs_detail.vue?vue&type=script&lang=js"
export * from "./sys_work_logs_detail.vue?vue&type=script&lang=js"
import style0 from "./sys_work_logs_detail.vue?vue&type=style&index=0&id=570ab4bc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570ab4bc",
  null
  
)

export default component.exports